import React from 'react';
import AccountContentComponent from './AccountContent';

export default function Account() {
  return (
    <div>
      <AccountContentComponent />
    </div >
  );
}



// WEBPACK FOOTER //
// ./src/views/Account/Account.jsx